<div class="card-preview-wrapper">
  <div
    class="card-preview-device"
    [ngStyle]="previewFrameStyle"
    [ngClass]="{ 'empty-card-preview': cardDetails.profile_status == 0 && cardDetails.darkMode == 1 }"
  >
    <div
      #scrollHost
      tabindex="0"
      class="card-preview-screen"
      [ngClass]="{ 'card-preview-screen-dark': templateMode === 1 }"
      [ngStyle]="previewFrameStyle"
      (mouseenter)="focusPreview()"
      (click)="focusPreview()"
      (wheel)="onPreviewWheel($event)"
      (keydown)="onPreviewKeydown($event)"
    >
      <div #previewContainer class="card-preview-mount"></div>
    </div>
  </div>
</div>
